import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  PhoneCall, UserCheck, Repeat, XCircle,
} from 'react-feather';
import { exibirNotificacaoSucesso, exibirNotificacao } from '../Store';
import NotificacaoErro from './NotificacaoErro';
import NotificacaoSucesso from './NotificacaoSucesso';
import { iconesNotificacao } from '../../../shared/util/Constantes';

import { FONT_FAMILY_SEMIBOLD, CORE_COLOR, TOMATO } from '../../../theme';

const useStyles = makeStyles(() => ({
  snackBar: {
    fontSize: '14px',
    fontWeight: 'bold',
    fill: 'solid',
    boxShadow: '0 2px 38px 0 rgba(0,0,0,0.07), 0 9px 15px 0 rgba(0,0,0,0.05)',
  },
  snackbarText: {
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: FONT_FAMILY_SEMIBOLD,
  },
}));

const Notificacao = (props) => {
  const {
    mensagemErro,
    mensagemSucesso,
    ocultarMensagemErro,
    ocultarMensagemSucesso,
    iconeSucesso,
    iconeErro,
  } = props;
  const classes = useStyles();

  const icones = {};
  icones[iconesNotificacao.LigacaoIniciada] = PhoneCall;
  icones[iconesNotificacao.AtendimentoFinalizado] = UserCheck;
  icones[iconesNotificacao.ErroPadrao] = XCircle;
  icones[iconesNotificacao.TentarNovamente] = Repeat;

  const renderizarIconeAlert = (icone, color, defaultIcon = null) => {
    let Icone = icones[icone];

    if (!Icone) {
      Icone = icones[defaultIcon];
    }

    return Icone ? <Icone color={color} /> : <></>;
  };

  const iconSucesso = renderizarIconeAlert(iconeSucesso, CORE_COLOR);
  const iconErro = renderizarIconeAlert(
    iconeErro,
    TOMATO,
    iconesNotificacao.ErroPadrao,
  );

  return (
    <>
      <NotificacaoErro
        mensagemErro={mensagemErro}
        ocultarMensagemErro={ocultarMensagemErro}
        classeSnackBar={classes.snackBar}
        classeSnackBarText={classes.snackbarText}
        iconeErro={iconErro}
      />
      <NotificacaoSucesso
        mensagemSucesso={mensagemSucesso}
        ocultarMensagemSucesso={ocultarMensagemSucesso}
        classeSnackBar={classes.snackBar}
        classeSnackBarText={classes.snackbarText}
        iconeSucesso={iconSucesso}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  mensagemErro: state.notificacao.notificacaoErro,
  iconeErro: state.notificacao.iconeErro,
  mensagemSucesso: state.notificacao.notificacaoSucesso,
  iconeSucesso: state.notificacao.iconeSucesso,
});

const mapDispatchToProps = (dispatch) => ({
  ocultarMensagemErro: () => dispatch(exibirNotificacao(null, null)),
  ocultarMensagemSucesso: () => dispatch(exibirNotificacaoSucesso(null, null)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notificacao);
